// extracted by mini-css-extract-plugin
module.exports = {"departments":"an-z","departmentHeading":"bn-z","departmentSection":"cn-z","departmentName":"dn-z","departmentLink":"en-z","expandIcon":"fn-z"};